<div class="sidebar-container">
    
    <div class="sidenav-booking">

        <a  class="mis-logo" href="#">
            <div>
                <img [src]="getSafeUrl()" alt="client logo">
            </div>
        </a>

        <a *ngIf="config?.personal.myBookings.config.visibility.visible" routerLink="/bookings" class="icon-container">
            <div routerLinkActive="RouterActive" class="card"> 
                <div class="nav-icons"  >
                    <img routerLinkActive="RouterIMG" src="assets/images/ic-nav-user-24.svg" alt="">
                </div>
                <div class="title">
                    My Bookings
                </div>
            </div>
        </a>

        <a *ngIf="config?.personal.myprofile.config.visibility.visible" routerLink="/profile">
            <div routerLinkActive="RouterActive" class="card">
                <div class="nav-icons" routerLinkActive="RouterActive">
                    <img routerLinkActive="RouterIMG" src="assets/images/ic-payment.svg" alt="">
                </div>
                <div class="title">
                    Manage Payment
                </div>
                
            </div>
        </a>
        <a *ngIf="config?.organization.bookingView.config.visibility.visible" href="" routerLink="/bookings-view">
            <div routerLinkActive="RouterActive" class="card">
                <div class="nav-icons" routerLinkActive="RouterActive">
                    <img routerLinkActive="RouterIMG booking-view-change" 
                      class="booking-view-icon" src="assets/images/ic-booking-view.svg" alt="">
                </div>
                <div class="title">
                    Booking View
                </div>

            </div>
        </a>

        <a   *ngIf="config?.cds.Tracking.config.visibility.visible" href="" routerLink="/tracking">
            <div routerLinkActive="RouterActive" class="card">
                <div class="nav-icons" routerLinkActive="RouterActive">
                    <img routerLinkActive="RouterIMG" src="assets/images/ic-ui-location-searching-24.svg" alt="">
                </div>
                <div class="title">
                    Tracking
                </div>

            </div>
        </a>

        <a  *ngIf="config?.billing.billingReports.config.visibility.visible" href="" routerLink="/billing-report">
            <div routerLinkActive="RouterActive" class="card">
                <div class="nav-icons" routerLinkActive="RouterActive">
                    <img routerLinkActive="RouterIMG" src="assets/images/ic-notepad.svg" alt="">
                </div>
                <div class="title">
                    Billing Reports
                </div>

            </div>

        </a>

        <a  *ngIf="config?.billing.invoicing.config.visibility.visible" href="" routerLink="/invoicing">
            <div routerLinkActive="RouterActive" class="card">
                <div class="nav-icons" routerLinkActive="RouterActive">
                    <img routerLinkActive="RouterIMG" src="assets/images/ic-nav-report-24.svg" alt="">
                </div>
                <div class="title">
                    Invoice & Payment
                </div>

            </div>

        </a>

         <!-- .......setting  -->
         <a *ngIf="config?.settings?.config?.visibility.visible">
            <div class="card">
                <div class="nav-icons">
                    <img src="assets/setting.svg" alt="">
                </div>
                <div class="title" (click)="showSettings()">
                    Settings
                    <span class="dropdownIcon"><img src="assets/caret-down-large.svg" alt="dropdown"></span>
                </div>

            </div>

        </a>

        <a *ngIf="settingList" routerLink="/auto-vendor-allocation" class="dropmenu">
            <div routerLinkActive="dropmenuCardRouterActive" class="card">
                <div class="nav-icons ">
                    <img src="assets/avaIcon.svg" alt="AVA">
                </div>
                <div class="title">
                    Auto Vendor Allocation
                </div>
            </div>

        </a>
        <a *ngIf="settingList" routerLink="/vehicle-allocation" class="dropmenu">
            <div routerLinkActive="dropmenuCardRouterActive" class="card">
                <div class="nav-icons ">
                    <img src="assets/dbvaIcon.svg" alt="DBVA">
                </div>
                <div class="title">
                    DBVA
                </div>
            </div>
        </a>
    </div>

</div>